webpackJsonp([2],{

/***/ 367:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(22)(
  /* script */
  __webpack_require__(370),
  /* template */
  __webpack_require__(377),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 370:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_shared__ = __webpack_require__(36);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  mixin: [__WEBPACK_IMPORTED_MODULE_0__mixins_shared__["a" /* default */]],
  data: function data() {
    return {
      email: '',
      loading: false
    };
  },

  methods: {
    forgotPass: function forgotPass() {
      var _this = this;

      this.loading = true;
      this.$fb.auth().sendPasswordResetEmail(this.email).then(function () {
        _this.loading = false;
        _this.addNotification({ text: 'You will recieve an email to reset your password', color: 'success' });
      }).catch(function (error) {
        _this.addNotification({ text: 'An error has occured, contact support', color: 'error' });
        _this.loading = false;
        console.log(error);
      });
    }
  }
});

/***/ }),

/***/ 377:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fill-height": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm2": "",
      "offset-sm5": ""
    }
  }, [_c('v-card', [(_vm.loading) ? _c('v-progress-linear', {
    attrs: {
      "indeterminate": true
    }
  }) : _vm._e(), _vm._v(" "), _c('v-card-text', [_c('v-container', [_c('h3', [_vm._v("Reset Password")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.forgotPass($event)
      }
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "email",
      "label": "Email Address",
      "id": "email",
      "type": "email",
      "required": ""
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "text-xs-center"
  }, [_c('v-btn', {
    attrs: {
      "type": "submit",
      "disabled": _vm.loading
    }
  }, [_vm._v("\n                    Send Password Request\n                  ")])], 1)])], 1)], 1)])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/2.6a597cc5cc7a3842acf4.js